module.exports = __webpack_public_path__ + "resources/img/img_cubrid_02_01_m.f7033c847be65ac5c07f53e8cac85621.png";